<template>
  <form-block
    :title="tr('Brand')"
    :description="tr('Select the brand for this automation. The ad account will be determined by the selected brand.')"
  >
    <brand-filter
      v-if="entity.isNew || entity.brand?.id"
      v-model="entity.brand.id"
      :all-option="false"
      :allow-inactive="!entity.isNew"
      :placeholder="tr('Select brand')"
      :disabled="disabled"
    />

    <transition-expand>
      <div v-if="entity.selectedAdAccount" class="flex flex-col gap-1.5">
        <ui-label>{{ tr('Ad Account') }}</ui-label>
        <div class="glass-tile flex items-center gap-2 rounded-lg px-3 py-2 text-sm">
          <i class="icon meta size-4" />
          <span>{{ entity.selectedAdAccount.name }}</span>
        </div>
      </div>
    </transition-expand>

    <asset-status-message
      :brand="entity.selectedBrand"
      :ad-account="entity.selectedAdAccount"
      :is-ai-mode="isAiMode"
    />
  </form-block>
</template>

<script>
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import AssetStatusMessage from '@/ui/components/AssetStatusMessage.vue';
import BrandFilter from '@/ui/components/BrandFilter.vue';
import TransitionExpand from '@/ui/components/TransitionExpand.vue';

export default {
  name: 'BrandBlock',
  components: {
    AssetStatusMessage,
    BrandFilter,
    TransitionExpand,
  },
  mixins: [ RuleFormBlockMixin ],
  computed: {
    isAiMode() {
      return this.$store.getters['ruleForm/isAiMode'];
    },
    brands() {
      return this.$root.currentCompany.brands || [];
    },
  },
  watch: {
    'entity.brand.id': {
      immediate: true,
      handler(val) {
        if (val) {
          this.entity.ad_account.id = this.entity.selectedBrand?.meta_ad_account?.id;
        }
      },
    },
  },
  mounted() {
    const activeBrands = this.brands.filter(brand => !brand.isInactive);
    if (activeBrands.length === 1 && !this.entity.brand.id) {
      this.entity.brand.id = activeBrands[0].id;
    }
  },
  methods: {
    validate() {
      if (!this.entity.selectedBrand) {
        if (this.entity.isNew) {
          this.error(this.tr('The {field} field cannot be empty!', { '{field}': this.tr('Brand') }));
          return false;
        }
      }

      if (this.entity.isNew && this.entity.selectedBrand.isInactive) {
        this.error(this.tr('validation.brand.inactive'));
        return false;
      }

      return true;
    },
  },
};
</script>
